import * as z from "zod";

const structuredLocationSchema = z.object({
  city: z.string().nullish(),
  state: z.string().nullish(),
  country: z.string().nullish(),
  postalCode: z.string().nullish(),
});

export interface StructuredLocation
  extends z.infer<typeof structuredLocationSchema> {}

const trackingLocationSchema_ = z.union([z.string(), structuredLocationSchema]);

export const trackingLocationSchema: z.ZodType<TrackingLocation> =
  trackingLocationSchema_;
export type TrackingLocation = {} & z.infer<typeof trackingLocationSchema_>;
